/**
 * Retail cart flyout — post–add-to-cart peek only.
 *
 * Opened from catalog grid pills (.js-grid-add-to-cart) in theme.js.liquid.
 * Does not replace Cart type (page / drawer / modal). Header cart icons and
 * Ajaxify drawer/modal stay on their own settings path.
 */
(function (window, document) {
  'use strict';

  function formatMoney(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || '${{amount}}');
    }
    var value = (Number(cents) || 0) / 100;
    return '$' + value.toFixed(2);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var RetailCartFlyout = {
    isOpen: false,
    el: null,
    listEl: null,
    moneyFormat: '${{amount}}',
    cartUrl: '/cart',

    init: function () {
      this.el = document.getElementById('js-retail-cart-flyout');
      this.listEl = document.getElementById('js-retail-cart-list');
      if (!this.el || !this.listEl) {
        return;
      }

      this.moneyFormat = this.el.getAttribute('data-money-format') || this.moneyFormat;
      this.cartUrl = this.el.getAttribute('data-cart-url') || this.cartUrl;

      this.el.removeAttribute('hidden');

      var closeBtn = this.el.querySelector('[data-retail-cart-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', this.close.bind(this));
      }

      this.listEl.addEventListener('click', this.onListClick.bind(this));

      document.addEventListener('keyup', function (evt) {
        if (evt.key === 'Escape' || evt.keyCode === 27) {
          RetailCartFlyout.close();
        }
      });
    },

    /** Open after a successful add-to-cart (caller must render cart first). */
    open: function () {
      if (!this.el) {
        return;
      }
      this.isOpen = true;
      this.el.classList.add('is-open');
    },

    close: function () {
      if (!this.el) {
        return;
      }
      this.isOpen = false;
      this.el.classList.remove('is-open');
    },

    updateCartCount: function (count) {
      var nodes = document.querySelectorAll('.cart-count');
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].textContent = String(count);
        if (count > 0) {
          nodes[i].classList.remove('hidden-count');
        } else {
          nodes[i].classList.add('hidden-count');
        }
      }
    },

    render: function (cart) {
      if (!this.listEl || !cart) {
        return;
      }

      var items = cart.items || [];
      if (!items.length) {
        this.listEl.innerHTML =
          '<div class="retail-cart-flyout__empty">' +
          '<h4>Your cart is empty</h4>' +
          '<p>Browse the catalog and add items to get started.</p>' +
          '</div>';
        return;
      }

      var html =
        '<div class="retail-cart-flyout__cart">' +
        '<div class="retail-cart-flyout__items">';

      for (var i = 0; i < items.length; i++) {
        html += this.renderItem(items[i], i + 1);
      }

      html +=
        '</div>' +
        '<div class="retail-cart-flyout__footer">' +
        '<span class="retail-cart-flyout__subtotal-label">Subtotal</span>' +
        '<span class="retail-cart-flyout__subtotal">' +
        formatMoney(cart.total_price, this.moneyFormat) +
        '</span>' +
        '</div>' +
        '<a class="retail-cart-flyout__checkout btn" href="' +
        escapeHtml(this.cartUrl) +
        '">View Cart / Checkout</a>' +
        '</div>';

      this.listEl.innerHTML = html;
    },

    renderItem: function (item, line) {
      var title = escapeHtml(item.product_title || item.title || 'Item');
      var url = escapeHtml(item.url || '#');
      var variant =
        item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="retail-cart-flyout__variant"><span class="retail-cart-flyout__meta-label">Option</span>' +
            escapeHtml(item.variant_title) +
            '</p>'
          : '';
      var image = item.image
        ? '<div class="retail-cart-flyout__media"><img class="retail-cart-flyout__thumb" src="' +
          escapeHtml(item.image) +
          '" alt=""/></div>'
        : '<div class="retail-cart-flyout__media retail-cart-flyout__media--placeholder" aria-hidden="true"></div>';

      return (
        '<article class="retail-cart-flyout__item" data-line="' +
        line +
        '">' +
        image +
        '<div class="retail-cart-flyout__body">' +
        '<div class="retail-cart-flyout__item-header">' +
        '<a href="' +
        url +
        '" class="retail-cart-flyout__item-title">' +
        title +
        '</a>' +
        '<button class="retail-cart-flyout__remove" type="button" data-line="' +
        line +
        '" aria-label="Remove ' +
        title +
        ' from cart" title="Remove item">&times;</button>' +
        '</div>' +
        variant +
        '<div class="retail-cart-flyout__meta">' +
        '<span class="retail-cart-flyout__qty"><span class="retail-cart-flyout__meta-label">Qty</span>' +
        item.quantity +
        '</span>' +
        '<span class="retail-cart-flyout__price">' +
        formatMoney(item.final_line_price != null ? item.final_line_price : item.line_price, this.moneyFormat) +
        '</span>' +
        '</div>' +
        '</div>' +
        '</article>'
      );
    },

    onListClick: function (evt) {
      var btn = evt.target.closest('[data-line].retail-cart-flyout__remove');
      if (!btn) {
        return;
      }
      evt.preventDefault();
      var line = parseInt(btn.getAttribute('data-line'), 10);
      if (!line) {
        return;
      }
      this.changeLine(line, 0);
    },

    changeLine: function (line, quantity) {
      var self = this;
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          self.render(cart);
          self.updateCartCount(cart.item_count);
        })
        .catch(function () {
          window.alert('Could not update cart');
        });
    }
  };

  window.RetailCartFlyout = RetailCartFlyout;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      RetailCartFlyout.init();
    });
  } else {
    RetailCartFlyout.init();
  }
})(window, document);
